// Subcategory detailed content
export const subcategoryContent: Record<string, any> = {
  "beverage-beer": {
    page_id: "industries-beverage-beer",
    slug: "/industries/beverage/beer",
    industry: "Beverage",
    subcategory: "Beer",
    meta: {
      title_gr: "Μπύρα | Λύσεις Επεξεργασίας & Συσκευασίας | TFT",
      title_en: "Beer | Processing & Packaging Solutions | TFT",
      description_gr: "Ολοκληρωμένες λύσεις TFT για ζυθοποίηση, πλήρωση και συσκευασία μπύρας — από το brewhouse έως την παλετοποίηση, με έμφαση στην ποιότητα, την αποδοτικότητα και την υγιεινή.",
      description_en: "Complete TFT solutions for brewing, filling, and beer packaging — from brewhouse to palletizing, focusing on quality, efficiency, and hygiene."
    },
    content: {
      intro_gr: "Η TFT προσφέρει ολοκληρωμένες λύσεις για όλα τα στάδια παραγωγής μπύρας, από το brewhouse και τη ζύμωση έως την πλήρωση σε μπουκάλια, κουτιά ή βαρέλια και την τελική παλετοποίηση. Οι εγκαταστάσεις μας σχεδιάζονται για μέγιστη αποδοτικότητα, διατήρηση της φρεσκάδας και ελάχιστη απώλεια προϊόντος.",
      intro_en: "TFT delivers end-to-end solutions for all beer production stages, from brewhouse and fermentation to bottling, canning, or kegging and final palletizing. Our facilities are designed for maximum efficiency, freshness preservation, and minimal product loss.",
      solutions: {
        process_gr: [
          "Brewhouse: άλεσμα, ζυθοποίηση, βρασμός λυκίσκου",
          "Συστήματα ζύμωσης και ωρίμανσης με ελεγχόμενη θερμοκρασία",
          "Διύλιση και καθαρισμός (filtration, clarification)",
          "Παστερίωση tunnel ή flash pasteurization",
          "Αποθήκευση σε δεξαμενές με έλεγχο CO₂ και θερμοκρασίας",
          "CIP/SIP συστήματα για απόλυτη υγιεινή",
          "Διαχείριση ζύμης και ανακύκλωση"
        ],
        process_en: [
          "Brewhouse: milling, mashing, hop boiling",
          "Fermentation and maturation systems with temperature control",
          "Filtration and clarification",
          "Tunnel or flash pasteurization",
          "Storage in tanks with CO₂ and temperature control",
          "CIP/SIP systems for absolute hygiene",
          "Yeast management and recycling"
        ],
        packaging_gr: [
          "Πλήρωση σε γυάλινα μπουκάλια (bottles) με rinser-filler-capper",
          "Canning lines για κουτιά αλουμινίου (single/multipack)",
          "Kegging συστήματα για ανοξείδωτα βαρέλια",
          "Καπάκωμα crown/twist-off, έλεγχος στεγανότητας",
          "Ετικετοποίηση, σφράγιση και date coding",
          "Δευτερογενής συσκευασία: εγκιβωτισμός, wrap-around, tray packing"
        ],
        packaging_en: [
          "Glass bottle filling with rinser-filler-capper",
          "Canning lines for aluminum cans (single/multipack)",
          "Kegging systems for stainless steel kegs",
          "Crown/twist-off capping, leak detection",
          "Labeling, sealing and date coding",
          "Secondary packaging: case packing, wrap-around, tray packing"
        ],
        automation_gr: [
          "Ρομποτικός χειρισμός μπουκαλιών, κουτιών και παλετών",
          "Αυτόματη παλετοποίηση με πολλαπλά patterns",
          "Μεταφορικά συστήματα και buffer zones",
          "Έλεγχος ποιότητας: μεταλλοανίχνευση, X-ray, έλεγχος επιπέδου",
          "Συλλογή δεδομένων παραγωγής και OEE monitoring"
        ],
        automation_en: [
          "Robotic handling of bottles, cans and pallets",
          "Automatic palletizing with multiple patterns",
          "Conveyor systems and buffer zones",
          "Quality control: metal detection, X-ray, level inspection",
          "Production data collection and OEE monitoring"
        ],
        lab_gr: [
          "Αυτόματοι αναλυτές τεχνολογίας FT-IR για την ανάλυση αλκοόλης, pH, πυκνότητας κα.",
          "Εξοπλισμός και αντιδραστήρια μικροβιολογικού ελέγχου",
          "Εξοπλισμός εργαστηρίου χημικών αναλύσεων σύστασης",
          "Τεχνική υποστήριξη από εξειδικευμένο προσωπικό"
        ],
        lab_en: [
          "FT-IR automatic analyzers for alcohol, pH, density and more",
          "Equipment and reagents for microbiological control",
          "Laboratory equipment for chemical composition analysis",
          "Technical support from specialized personnel"
        ],
        services_gr: [
          "Σχεδιασμός ζυθοποιείου και προσομοίωση γραμμής",
          "Εγκατάσταση, commissioning και εκπαίδευση",
          "Συμβόλαια συντήρησης και 24/7 υποστήριξη",
          "Βελτιστοποίηση συνταγών και energy efficiency audits"
        ],
        services_en: [
          "Brewery design and line simulation",
          "Installation, commissioning and training",
          "Maintenance contracts and 24/7 support",
          "Recipe optimization and energy efficiency audits"
        ]
      },
      benefits_gr: [
        "Διατήρηση φρεσκάδας και οργανοληπτικών χαρακτηριστικών",
        "Υψηλή αποδοτικότητα γραμμής και ελάχιστες απώλειες",
        "Ευελιξία για πολλαπλά formats (μπουκάλι, κουτί, βαρέλι)",
        "Πλήρης ιχνηλασιμότητα και compliance με πρότυπα ποιότητας"
      ],
      benefits_en: [
        "Freshness and sensory characteristics preservation",
        "High line efficiency and minimal losses",
        "Flexibility for multiple formats (bottle, can, keg)",
        "Full traceability and quality standards compliance"
      ]
    }
  },
  "beverage-wine": {
    page_id: "industries-beverage-wine",
    slug: "/industries/beverage/wine",
    industry: "Beverage",
    subcategory: "Wine",
    meta: {
      title_gr: "Οίνος | Λύσεις Επεξεργασίας & Συσκευασίας | TFT",
      title_en: "Wine | Processing & Packaging Solutions | TFT",
      description_gr: "Ολοκληρωμένες λύσεις TFT για οινοποίηση, ωρίμανση και συσκευασία κρασιού — από τη διαύγαση έως την πλήρωση σε μπουκάλια, με σεβασμό στην ποιότητα και την παράδοση.",
      description_en: "Complete TFT solutions for winemaking, aging, and wine packaging — from clarification to bottling, respecting quality and tradition."
    },
    content: {
      intro_gr: "Η TFT παρέχει λύσεις που συνδυάζουν την παραδοσιακή οινοποίηση με σύγχρονη τεχνολογία, καλύπτοντας όλα τα στάδια από την παραλαβή σταφυλιού, τη ζύμωση και την ωρίμανση έως την πλήρωση και την παλετοποίηση. Σχεδιάζουμε με γνώμονα τη διατήρηση των οργανοληπτικών χαρακτηριστικών, την ελαχιστοποίηση οξυγόνωσης και τη βέλτιστη διαχείριση του προϊόντος.",
      intro_en: "TFT provides solutions combining traditional winemaking with modern technology, covering all stages from grape reception, fermentation, and aging to bottling and palletizing. We design with focus on preserving organoleptic characteristics, minimizing oxidation, and optimal product handling.",
      solutions: {
        process_gr: [
          "Παραλαβή και εκκοκκισμός σταφυλιών (destemmer-crusher)",
          "Συστήματα ζύμωσης σε δεξαμενές (ανοξείδωτες ή ξύλινες)",
          "Έλεγχος θερμοκρασίας και ανάμειξη κατά τη ζύμωση",
          "Διύλιση, καθαρισμός και σταθεροποίηση",
          "Ωρίμανση σε δρύινα βαρέλια ή δεξαμενές",
          "Microfiltration και cold stabilization",
          "CIP συστήματα για όλο τον εξοπλισμό επεξεργασίας"
        ],
        process_en: [
          "Grape reception and destemming-crushing",
          "Fermentation systems in tanks (stainless or wooden)",
          "Temperature control and mixing during fermentation",
          "Filtration, clarification and stabilization",
          "Aging in oak barrels or tanks",
          "Microfiltration and cold stabilization",
          "CIP systems for all processing equipment"
        ],
        packaging_gr: [
          "Πλήρωση σε γυάλινα μπουκάλια με isobaric ή gravity fillers",
          "Cork, screw cap ή synthetic closure εφαρμογή",
          "Wire-hooding για αφρώδεις οίνους",
          "Ετικετοποίηση (front, back, neck labels)",
          "Capsule εφαρμογή και θερμοσυστολή",
          "Δευτερογενής συσκευασία: κιβώτια ξύλινα ή χαρτονιού"
        ],
        packaging_en: [
          "Glass bottle filling with isobaric or gravity fillers",
          "Cork, screw cap or synthetic closure application",
          "Wire-hooding for sparkling wines",
          "Labeling (front, back, neck labels)",
          "Capsule application and heat shrink",
          "Secondary packaging: wooden or cardboard cases"
        ],
        automation_gr: [
          "Αυτόματη ταξινόμηση και προετοιμασία μπουκαλιών",
          "Ρομποτικός εγκιβωτισμός για premium συσκευασία",
          "Παλετοποίηση με ειδικά patterns για οίνο",
          "Έλεγχος επιπέδου, καπακώματος και ετικέτας",
          "Traceability systems για lot και batch tracking"
        ],
        automation_en: [
          "Automatic bottle sorting and preparation",
          "Robotic case packing for premium packaging",
          "Palletizing with wine-specific patterns",
          "Level, closure and label inspection",
          "Traceability systems for lot and batch tracking"
        ],
        lab_gr: [
          "Αυτόματοι αναλυτές τεχνολογίας FT-IR για την ανάλυση αλκοόλης, pH, πυκνότητας κ.α. σε οίνο, γλεύκος, γλεύκος υπό ζύμωση και αφρώδη οίνο",
          "Τεχνική υποστήριξη από εξειδικευμένο προσωπικό"
        ],
        lab_en: [
          "FT-IR automatic analyzers for alcohol, pH, density and more in wine, must, fermenting must, and sparkling wine",
          "Technical support from specialized personnel"
        ],
        services_gr: [
          "Μελέτη οινοποιείου και βελτιστοποίηση ροών",
          "Εγκατάσταση, commissioning και εκπαίδευση προσωπικού",
          "Προγράμματα συντήρησης και ανταλλακτικά",
          "Τεχνική υποστήριξη και συμβουλευτική οινοποίησης"
        ],
        services_en: [
          "Winery design and flow optimization",
          "Installation, commissioning and staff training",
          "Maintenance programs and spare parts",
          "Technical support and winemaking consultancy"
        ]
      },
      benefits_gr: [
        "Διατήρηση αρωμάτων και χαρακτήρα του κρασιού",
        "Ελαχιστοποίηση οξυγόνωσης και μικροβιακών μολύνσεων",
        "Ευελιξία για διαφορετικούς τύπους οίνων (ερυθρός, λευκός, rosé, αφρώδης)",
        "Πλήρης έλεγχος και ιχνηλασιμότητα από το αμπέλι στο μπουκάλι"
      ],
      benefits_en: [
        "Preservation of wine aromas and character",
        "Minimization of oxidation and microbial contamination",
        "Flexibility for different wine types (red, white, rosé, sparkling)",
        "Full control and traceability from vine to bottle"
      ]
    }
  },
  "beverage-soft-drinks": {
    page_id: "industries-beverage-soft-drinks",
    slug: "/industries/beverage/soft-drinks",
    industry: "Beverage",
    subcategory: "Soft Drinks",
    meta: {
      title_gr: "Αναψυκτικά | Λύσεις Επεξεργασίας & Συσκευασίας | TFT",
      title_en: "Soft Drinks | Processing & Packaging Solutions | TFT",
      description_gr: "Ολοκληρωμένες λύσεις TFT για παραγωγή και συσκευασία αναψυκτικών — ανθρακούχα, μη ανθρακούχα, ενεργειακά ποτά και isotonic — με έμφαση στη σταθερή ποιότητα και την αποδοτικότητα.",
      description_en: "Complete TFT solutions for soft drink production and packaging — carbonated, still, energy drinks and isotonic — focusing on consistent quality and efficiency."
    },
    content: {
      intro_gr: "Η TFT σχεδιάζει και υλοποιεί ολοκληρωμένες γραμμές για όλους τους τύπους αναψυκτικών, από την προετοιμασία σιροπιού και την ανάμειξη έως την πλήρωση σε μπουκάλια PET/γυάλινα ή κουτιά και την παλετοποίηση. Δίνουμε έμφαση στην ακρίβεια δοσομέτρησης, την καθαριότητα, την ταχύτητα γραμμής και τη μείωση απωλειών.",
      intro_en: "TFT designs and implements complete lines for all soft drink types, from syrup preparation and mixing to PET/glass bottle or can filling and palletizing. We emphasize dosing accuracy, cleanliness, line speed, and waste reduction.",
      solutions: {
        process_gr: [
          "Προετοιμασία σιροπιού (syrup preparation) με ακριβή δοσομέτρηση συστατικών",
          "Blending συστήματα για ανάμειξη νερού, σιροπιού και πρόσθετων",
          "Ανθρακοποίηση (carbonation) με έλεγχο CO₂ επιπέδων",
          "Παστερίωση ή aseptic processing ανάλογα με το προϊόν",
          "Συστήματα φιλτραρίσματος και UV απολύμανσης",
          "CIP/SIP αυτοματισμοί για δεξαμενές και γραμμές",
          "Αποθήκευση έτοιμου προϊόντος σε ελεγχόμενη θερμοκρασία"
        ],
        process_en: [
          "Syrup preparation with precise ingredient dosing",
          "Blending systems for water, syrup and additives mixing",
          "Carbonation with controlled CO₂ levels",
          "Pasteurization or aseptic processing depending on product",
          "Filtration and UV disinfection systems",
          "CIP/SIP automation for tanks and lines",
          "Finished product storage at controlled temperature"
        ],
        packaging_gr: [
          "Blow-moulding για PET μπουκάλια on-site (preform to bottle)",
          "Πλήρωση PET με rinser-filler-capper (isobaric για ανθρακούχα)",
          "Γυάλινα μπουκάλια με καπάκωμα twist-off/crown",
          "Canning lines για αλουμινένια κουτιά",
          "Ετικετοποίηση (roll-fed, self-adhesive, sleeve)",
          "Date coding, lot marking και traceability",
          "Δευτερογενής συσκευασία: shrink wrap, tray packing, case packing"
        ],
        packaging_en: [
          "On-site PET blow-molding (preform to bottle)",
          "PET filling with rinser-filler-capper (isobaric for carbonated)",
          "Glass bottles with twist-off/crown capping",
          "Canning lines for aluminum cans",
          "Labeling (roll-fed, self-adhesive, sleeve)",
          "Date coding, lot marking and traceability",
          "Secondary packaging: shrink wrap, tray packing, case packing"
        ],
        automation_gr: [
          "Ρομποτικός χειρισμός preforms, μπουκαλιών και κιβωτίων",
          "Αυτόματη παλετοποίηση/αποπαλετοποίηση",
          "Μεταφορικά συστήματα με buffer zones για συνεχή ροή",
          "Έλεγχος ποιότητας: επίπεδο πλήρωσης, καπάκωμα, ετικέτα",
          "MES/SCADA για πλήρη έλεγχο παραγωγής και ιχνηλασιμότητα"
        ],
        automation_en: [
          "Robotic handling of preforms, bottles and cases",
          "Automatic palletizing/depalletizing",
          "Conveyor systems with buffer zones for continuous flow",
          "Quality control: fill level, capping, label inspection",
          "MES/SCADA for full production control and traceability"
        ],
        lab_gr: [
          "Εξοπλισμός και αντιδραστήρια μικροβιολογικού ελέγχου",
          "Εξοπλισμός εργαστηρίου χημικών αναλύσεων σύστασης",
          "Τεχνική υποστήριξη από εξειδικευμένο προσωπικό"
        ],
        lab_en: [
          "Equipment and reagents for microbiological control",
          "Laboratory equipment for chemical composition analysis",
          "Technical support from specialized personnel"
        ],
        services_gr: [
          "Μελέτη εγκατάστασης και capacity planning",
          "Εγκατάσταση, commissioning και operator training",
          "Συμβόλαια συντήρησης και απομακρυσμένη υποστήριξη",
          "Βελτιστοποίηση συνταγών και energy audits"
        ],
        services_en: [
          "Plant design and capacity planning",
          "Installation, commissioning and operator training",
          "Maintenance contracts and remote support",
          "Recipe optimization and energy audits"
        ]
      },
      benefits_gr: [
        "Υψηλή ταχύτητα γραμμής με σταθερή ποιότητα προϊόντος",
        "Ευελιξία για διαφορετικά formats (PET, γυαλί, κουτί)",
        "Ελάχιστες απώλειες και βελτιστοποιημένη κατανάλωση ενέργειας",
        "Πλήρης ιχνηλασιμότητα και food safety compliance"
      ],
      benefits_en: [
        "High line speed with consistent product quality",
        "Flexibility for different formats (PET, glass, can)",
        "Minimal losses and optimized energy consumption",
        "Full traceability and food safety compliance"
      ]
    }
  },
  "beverage-juices": {
    page_id: "industries-beverage-juices",
    slug: "/industries/beverage/juices",
    industry: "Beverage",
    subcategory: "Juices",
    meta: {
      title_gr: "Χυμοί | Λύσεις Επεξεργασίας & Συσκευασίας | TFT",
      title_en: "Juices | Processing & Packaging Solutions | TFT",
      description_gr: "Ολοκληρωμένες λύσεις TFT για παραγωγή και συσκευασία χυμών — NFC, από συμπύκνωμα, nectars — με διατήρηση θρεπτικών συστατικών και φρεσκάδας.",
      description_en: "Complete TFT solutions for juice production and packaging — NFC, from concentrate, nectars — preserving nutrients and freshness."
    },
    content: {
      intro_gr: "Η TFT προσφέρει ολοκληρωμένες λύσεις για όλα τα στάδια παραγωγής χυμών, από την παραλαβή φρούτων/λαχανικών, την εκχύλιση και την επεξεργασία έως την aseptic ή hot-fill πλήρωση και την τελική παλετοποίηση. Σχεδιάζουμε με γνώμονα τη διατήρηση των βιταμινών, του χρώματος και της γεύσης.",
      intro_en: "TFT provides end-to-end solutions for all juice production stages, from fruit/vegetable reception, extraction and processing to aseptic or hot-fill packaging and final palletizing. We design to preserve vitamins, color, and taste.",
      solutions: {
        process_gr: [
          "Παραλαβή, πλύση και ταξινόμηση φρούτων/λαχανικών",
          "Εκχύλιση χυμού (pressing, extraction) και διαχωρισμός πολφού",
          "Ενζυματική επεξεργασία για διαύγαση και απόδοση",
          "Παστερίωση ή UHT επεξεργασία με ήπιες θερμοκρασίες",
          "Συμπύκνωση (concentration) για μεταφορά ή αποθήκευση",
          "Ανασύσταση από συμπύκνωμα (reconstitution)",
          "Blending για σταθερή γεύση και Brix",
          "Aseptic ή hot-fill συστήματα πλήρωσης",
          "CIP/SIP για απόλυτη υγιεινή"
        ],
        process_en: [
          "Fruit/vegetable reception, washing and sorting",
          "Juice extraction (pressing) and pulp separation",
          "Enzymatic treatment for clarification and yield",
          "Pasteurization or UHT with gentle temperatures",
          "Concentration for transport or storage",
          "Reconstitution from concentrate",
          "Blending for consistent taste and Brix",
          "Aseptic or hot-fill systems",
          "CIP/SIP for absolute hygiene"
        ],
        packaging_gr: [
          "Aseptic πλήρωση σε carton (gable-top, brick)",
          "Hot-fill σε PET ή γυάλινα μπουκάλια",
          "Πλήρωση pouch/bag-in-box για foodservice",
          "Καπάκωμα με safety seals",
          "Ετικετοποίηση και nutritional labeling",
          "Δευτερογενής συσκευασία: shrink wrap, case packing, carton wrap-around"
        ],
        packaging_en: [
          "Aseptic filling in carton (gable-top, brick)",
          "Hot-fill in PET or glass bottles",
          "Pouch/bag-in-box filling for foodservice",
          "Capping with safety seals",
          "Labeling and nutritional labeling",
          "Secondary packaging: shrink wrap, case packing"
        ],
        automation_gr: [
          "Αυτόματη ταξινόμηση φρούτων με optical sorting",
          "Ρομποτικός χειρισμός cartons και παλετών",
          "Buffer συστήματα για συνεχή παραγωγή",
          "Έλεγχος ποιότητας: Brix, χρώμα, μεταλλοανίχνευση",
          "Traceability από φρούτο έως τελικό προϊόν"
        ],
        automation_en: [
          "Automatic fruit sorting with optical sorting",
          "Robotic handling of cartons and pallets",
          "Buffer systems for continuous production",
          "Quality control: Brix, color, metal detection",
          "Traceability from fruit to final product"
        ],
        lab_gr: [
          "Ανάλυση Brix, pH, οξύτητας και θρεπτικών συστατικών",
          "Μικροβιολογικός έλεγχος και shelf-life testing"
        ],
        lab_en: [
          "Brix, pH, acidity and nutritional analysis",
          "Microbiological control and shelf-life testing"
        ],
        services_gr: [
          "Σχεδιασμός juice plant και process optimization",
          "Εγκατάσταση, commissioning και εκπαίδευση",
          "Συμβόλαια συντήρησης και τεχνική υποστήριξη",
          "Ανάπτυξη συνταγών και product development"
        ],
        services_en: [
          "Juice plant design and process optimization",
          "Installation, commissioning and training",
          "Maintenance contracts and technical support",
          "Recipe development and product development"
        ]
      },
      benefits_gr: [
        "Διατήρηση βιταμινών, αρωμάτων και θρεπτικής αξίας",
        "Υψηλή απόδοση εκχύλισης και ελάχιστες απώλειες",
        "Ευελιξία για NFC, από συμπύκνωμα, nectars και smoothies",
        "Long shelf-life με ασηπτική τεχνολογία"
      ],
      benefits_en: [
        "Preservation of vitamins, aromas and nutritional value",
        "High extraction yield and minimal losses",
        "Flexibility for NFC, from concentrate, nectars and smoothies",
        "Extended shelf-life with aseptic technology"
      ]
    }
  },
  "dairy-milk": {
    page_id: "industries-dairy-milk",
    slug: "/industries/dairy/milk",
    industry: "Dairy",
    subcategory: "Milk",
    meta: {
      title_gr: "Λύσεις Επεξεργασίας & Συσκευασίας | TFT",
      title_en: "Processing & Packaging Solutions | TFT",
      description_gr: "Ολοκληρωμένες λύσεις TFT για την παραλαβή, επεξεργασία και πρωτογενή/δευτερογενή συσκευασία γάλακτος, με έμφαση στην υγιεινή, τη σταθερή ποιότητα προϊόντος και τη λειτουργική αποδοτικότητα.",
      description_en: "Complete TFT solutions for milk reception, processing, and primary/secondary packaging, with emphasis on hygiene, consistent product quality, and operational efficiency."
    },
    content: {
      intro_gr: "Η TFT προσφέρει ολοκληρωμένες λύσεις για τη διαχείριση και επεξεργασία γάλακτος, καλύπτοντας όλα τα στάδια από την παραλαβή της πρώτης ύλης έως την τελική συσκευασία και παλετοποίηση. Οι λύσεις μας έχουν σχεδιαστεί ώστε να ανταποκρίνονται στις αυστηρές απαιτήσεις υγιεινής, ποιότητας και ιχνηλασιμότητας που χαρακτηρίζουν την παραγωγή γάλακτος.\n\nΥποστηρίζουμε ευέλικτα διαφορετικούς τύπους προϊόντων, όπως παστεριωμένο, ESL και UHT γάλα, διασφαλίζοντας σταθερή ποιότητα, αυξημένη διάρκεια ζωής και αποδοτική λειτουργία γραμμής, ανεξαρτήτως format συσκευασίας.",
      intro_en: "TFT offers complete solutions for milk handling and processing, covering all stages from raw material reception to final packaging and palletizing. Our solutions are designed to meet the strict hygiene, quality, and traceability requirements that characterize milk production.\n\nWe flexibly support different product types, such as pasteurized, ESL, and UHT milk, ensuring consistent quality, extended shelf life, and efficient line operation, regardless of packaging format.",
      overview_gr: "Οι λύσεις επεξεργασίας γάλακτος της TFT καλύπτουν όλες τις βασικές διεργασίες της παραγωγής, με υγιεινό σχεδιασμό και έλεγχο κρίσιμων παραμέτρων σε κάθε στάδιο.",
      overview_en: "TFT's milk processing solutions cover all key production processes, with hygienic design and control of critical parameters at every stage.",
      solutions: {
        process_gr: [
          "Παραλαβή και αποθήκευση πρώτης ύλης με ψύξη και πλήρη ιχνηλασιμότητα",
          "Καθαρισμός, διαύγαση και διαχωρισμός (clarification & separation)",
          "Τυποποίηση λιποπεριεκτικότητας (standardization)",
          "Ομογενοποίηση και απαέρωση (homogenization & deaeration)",
          "Θερμική επεξεργασία: HTST παστερίωση, ESL ή UHT / aseptic",
          "Αυτοματοποιημένα συστήματα CIP / SIP και υγιεινός σχεδιασμός εγκαταστάσεων",
          "Εναλλακτικές διεργασίες, όπως μικροδιήθηση ή φιλτράρισμα, όπου απαιτείται"
        ],
        process_en: [
          "Raw material reception and storage with cooling and full traceability",
          "Cleaning, clarification and separation",
          "Fat content standardization",
          "Homogenization and deaeration",
          "Heat treatment: HTST pasteurization, ESL or UHT / aseptic",
          "Automated CIP / SIP systems and hygienic plant design",
          "Alternative processes, such as microfiltration or filtration, where required"
        ],
        packaging_gr: [
          "Πλήρωση σε φιάλες (HDPE / PET) ή σε carton / aseptic συσκευασία",
          "Κλείσιμο, καπάκωμα και σφράγιση",
          "Έλεγχος διαρροών και ακεραιότητας συσκευασίας",
          "Ετικετοποίηση, εκτύπωση ημερομηνίας και lot, συστήματα ιχνηλασιμότητας",
          "Δευτερογενής συσκευασία: κιβώτια, δεματοποίηση, δίσκοι και καπάκια"
        ],
        packaging_en: [
          "Filling in bottles (HDPE / PET) or carton / aseptic packaging",
          "Closing, capping and sealing",
          "Leak detection and packaging integrity control",
          "Labeling, date and lot printing, traceability systems",
          "Secondary packaging: cases, bundling, trays and lids"
        ],
        packaging_intro_gr: "Η TFT προσφέρει ολοκληρωμένες λύσεις συσκευασίας γάλακτος, σχεδιασμένες για ασφάλεια προϊόντος, ευελιξία και σταθερή ποιότητα.",
        packaging_intro_en: "TFT offers complete milk packaging solutions, designed for product safety, flexibility, and consistent quality.",
        automation_gr: [
          "Εγκιβωτισμός (case packing) και ομαδοποίηση multipacks",
          "Ρομποτικός χειρισμός και παλετοποίηση με προκαθορισμένα patterns",
          "Μεταφορικά συστήματα, buffers και συγκεντρωτικές ροές",
          "Συλλογή και ανάλυση δεδομένων παραγωγής",
          "OEE dashboards και διασύνδεση με συστήματα SCADA / MES"
        ],
        automation_en: [
          "Case packing and multipack grouping",
          "Robotic handling and palletizing with predefined patterns",
          "Conveyor systems, buffers and accumulation flows",
          "Production data collection and analysis",
          "OEE dashboards and integration with SCADA / MES systems"
        ],
        automation_intro_gr: "Οι λύσεις αυτοματισμού της TFT διασφαλίζουν ομαλή ροή παραγωγής, υψηλή διαθεσιμότητα γραμμής και αξιόπιστη διαχείριση τελικού προϊόντος.",
        automation_intro_en: "TFT automation solutions ensure smooth production flow, high line availability, and reliable finished product management.",
        lab_gr: [
          "Παροχή εργαστηριακού εξοπλισμού για αυτοματοποιημένη ανάλυση και έλεγχο ποιότητας σε πραγματικό χρόνο",
          "Ταχεία και αξιόπιστη ανάλυση λίπους, πρωτεΐνης, λακτόζης, ολικών στερεών, κρυοσκοπικού σημείου κ.α.",
          "Τεχνική υποστήριξη από εξειδικευμένο προσωπικό"
        ],
        lab_en: [
          "Supply of laboratory equipment for automated analysis and real-time quality control",
          "Rapid and reliable analysis of fat, protein, lactose, total solids, freezing point, and more",
          "Technical support from specialized personnel"
        ],
        turnkey_gr: "Η TFT αναλαμβάνει τον σχεδιασμό και την υλοποίηση ολοκληρωμένων γραμμών παραγωγής γάλακτος με το κλειδί στο χέρι. Από τη μελέτη και τη διαστασιολόγηση έως τη θέση σε λειτουργία, λειτουργούμε ως ενιαίος συνεργάτης, διασφαλίζοντας ομαλή ενσωμάτωση επεξεργασίας, συσκευασίας, αυτοματισμών και ποιοτικού ελέγχου.\n\nΗ turnkey προσέγγιση μειώνει το ρίσκο υλοποίησης, επιταχύνει την απόδοση της επένδυσης και προσφέρει λύσεις σχεδιασμένες για μακροχρόνια λειτουργία και μελλοντική επέκταση.",
        turnkey_en: "TFT undertakes the design and implementation of complete milk production lines on a turnkey basis. From study and sizing to commissioning, we operate as a single partner, ensuring smooth integration of processing, packaging, automation, and quality control.\n\nThe turnkey approach reduces implementation risk, accelerates return on investment, and offers solutions designed for long-term operation and future expansion.",
        services_gr: [
          "Μελέτη γραμμής και διαστασιολόγηση εξοπλισμού",
          "Εγκατάσταση, commissioning και εκπαίδευση προσωπικού",
          "Συμβόλαια συντήρησης, ανταλλακτικά και απομακρυσμένη υποστήριξη",
          "Βελτιστοποίηση διεργασιών, συνταγών και ενεργειακής κατανάλωσης"
        ],
        services_en: [
          "Line study and equipment sizing",
          "Installation, commissioning and staff training",
          "Maintenance contracts, spare parts and remote support",
          "Process, recipe and energy consumption optimization"
        ]
      },
      benefits_categories_gr: [
        {
          title: "Ποιότητα & Ασφάλεια",
          items: [
            "Υγιεινός σχεδιασμός και πλήρης συμμόρφωση με διεθνή πρότυπα ασφάλειας τροφίμων",
            "Σταθερή ποιότητα προϊόντος και πλήρης ιχνηλασιμότητα"
          ]
        },
        {
          title: "Απόδοση & Αξιοπιστία",
          items: [
            "Υψηλή αποδοτικότητα γραμμής και μειωμένες απώλειες προϊόντος",
            "Ελεγχόμενες και επαναλήψιμες διεργασίες"
          ]
        },
        {
          title: "Ευελιξία & Ανάπτυξη",
          items: [
            "Υποστήριξη διαφορετικών τύπων συσκευασίας (Carton Gable Top/Roll-Fed, HDPE, PET, Glass)",
            "Ευελιξία σε HTST, ESL και UHT ροές",
            "Υποδομή για μελλοντική επέκταση και νέες απαιτήσεις αγοράς"
          ]
        }
      ],
      benefits_categories_en: [
        {
          title: "Quality & Safety",
          items: [
            "Hygienic design and full compliance with international food safety standards",
            "Consistent product quality and full traceability"
          ]
        },
        {
          title: "Performance & Reliability",
          items: [
            "High line efficiency and reduced product losses",
            "Controlled and repeatable processes"
          ]
        },
        {
          title: "Flexibility & Growth",
          items: [
            "Support for different formats (HDPE, PET, carton)",
            "Flexibility in HTST, ESL and UHT flows",
            "Infrastructure for future expansion and new market requirements"
          ]
        }
      ],
      benefits_gr: [
        "Υγιεινός σχεδιασμός και πλήρης συμμόρφωση με διεθνή πρότυπα ασφάλειας τροφίμων",
        "Σταθερή ποιότητα προϊόντος και πλήρης ιχνηλασιμότητα",
        "Υψηλή αποδοτικότητα γραμμής και μειωμένες απώλειες προϊόντος",
        "Ελεγχόμενες και επαναλήψιμες διεργασίες",
        "Υποστήριξη διαφορετικών formats (HDPE, PET, carton)",
        "Ευελιξία σε HTST, ESL και UHT ροές",
        "Υποδομή για μελλοντική επέκταση και νέες απαιτήσεις αγοράς"
      ],
      benefits_en: [
        "Hygienic design and full compliance with international food safety standards",
        "Consistent product quality and full traceability",
        "High line efficiency and reduced product losses",
        "Controlled and repeatable processes",
        "Support for different formats (HDPE, PET, carton)",
        "Flexibility in HTST, ESL and UHT flows",
        "Infrastructure for future expansion and new market requirements"
      ]
    }
  },
  "dairy-yoghurt": {
    page_id: "industries-dairy-yoghurt",
    slug: "/industries/dairy/yoghurt",
    industry: "Dairy",
    subcategory: "Yoghurt",
    meta: {
      title_gr: "Λύσεις Επεξεργασίας & Συσκευασίας | TFT",
      title_en: "Processing & Packaging Solutions | TFT",
      description_gr: "Η TFT προσφέρει ολοκληρωμένες λύσεις για κάθε στάδιο παραγωγής γιαουρτιού — από την προετοιμασία του μίγματος έως τη ζύμωση, τη συσκευασία και τον τελικό χειρισμό του προϊόντος. Οι γραμμές μας σχεδιάζονται με στόχο την ασφάλεια τροφίμων, τη βέλτιστη υφή, τη σταθερή ποιότητα και την υψηλή αποδοτικότητα, υποστηρίζοντας όλους τους τύπους γιαουρτιού: set, stirred, strained και Greek-style.",
      description_en: "TFT provides complete solutions for every stage of yogurt production — from milk preparation to fermentation, packaging, and finished product handling. Our lines are designed for food safety, optimal texture, consistent quality, and high operational efficiency, supporting all yogurt types: set, stirred, strained, and Greek-style."
    },
    content: {
      intro_gr: "Η TFT προσφέρει ολοκληρωμένες λύσεις για κάθε στάδιο παραγωγής γιαουρτιού — από την προετοιμασία του μίγματος έως τη ζύμωση, τη συσκευασία και τον τελικό χειρισμό του προϊόντος. Οι γραμμές μας σχεδιάζονται με στόχο την ασφάλεια τροφίμων, τη βέλτιστη υφή, τη σταθερή ποιότητα και την υψηλή αποδοτικότητα, υποστηρίζοντας όλους τους τύπους γιαουρτιού: set, stirred, strained και Greek-style.",
      intro_en: "TFT provides complete solutions for every stage of yogurt production — from milk preparation to fermentation, packaging, and finished product handling. Our lines are designed for food safety, optimal texture, consistent quality, and high operational efficiency, supporting all yogurt types: set, stirred, strained, and Greek-style.",
      overview_gr: "Η παραγωγή γιαουρτιού απαιτεί ακριβή έλεγχο μικροβιολογικών συνθηκών, θερμικής επεξεργασίας και ζύμωσης, καθώς και διαχείριση προϊόντων υψηλού ιξώδους που καθορίζουν την υφή και τη σταθερότητα. Οι λύσεις της TFT ενσωματώνουν υγιεινό σχεδιασμό, προηγμένους αυτοματισμούς και συνεχή παρακολούθηση διεργασιών, διασφαλίζοντας επαναληψιμότητα και ομοιομορφία παρτίδων.",
      overview_en: "Yogurt production requires precise control of microbiological conditions, thermal processing, fermentation parameters, and high-viscosity product handling, all of which define texture and stability. TFT's solutions integrate hygienic design, advanced automation, and continuous process monitoring to ensure batch consistency and reliable quality.",
      solutions: {
        turnkey_gr: "Η TFT αναλαμβάνει τον σχεδιασμό και την υλοποίηση ολοκληρωμένων γραμμών παραγωγής γιαουρτιού με το κλειδί στο χέρι. Από τη μελέτη και τη διαστασιολόγηση έως τη θέση σε λειτουργία, λειτουργούμε ως ενιαίος συνεργάτης, εξασφαλίζοντας ομαλή ενσωμάτωση επεξεργασίας, συσκευασίας, αυτοματισμών και ποιοτικού ελέγχου.\n\nΗ turnkey προσέγγιση μειώνει το ρίσκο υλοποίησης, επιταχύνει την απόδοση της επένδυσης και προσφέρει υποδομές σχεδιασμένες για μακροχρόνια λειτουργία και μελλοντική επέκταση.",
        turnkey_en: "TFT designs and delivers complete yogurt production lines on a turnkey basis. From engineering and equipment sizing to commissioning, we act as a single point of responsibility, ensuring seamless integration of processing, packaging, automation, and quality control.\n\nThis approach reduces project risk, accelerates return on investment, and delivers solutions designed for long-term operation and future expansion.",
        process_gr: [
          "Προετοιμασία και τυποποίηση μίγματος γάλακτος",
          "Θερμική επεξεργασία (HTST ή UHT ανάλογα με το προϊόν)",
          "Ομογενοποίηση για σταθερότητα και υφή",
          "Εμβολιασμός με καλλιέργειες",
          "Ελεγχόμενη ζύμωση σε δεξαμενές ή απευθείας σε κύπελλα (set yoghurt)",
          "Αναδευτήρες, ψύξη και έλεγχος ιξώδους για stirred ή strained προϊόντα",
          "CIP/SIP συστήματα για απόλυτη υγιεινή και ελαχιστοποίηση downtime"
        ],
        process_en: [
          "Milk mixture preparation and standardization",
          "Thermal processing (HTST or UHT depending on the product)",
          "Homogenization for stability and texture",
          "Inoculation with cultures",
          "Controlled fermentation in tanks or directly in cups (set yoghurt)",
          "Agitation, cooling, and viscosity control for stirred or strained products",
          "CIP/SIP systems ensuring hygiene and minimal downtime"
        ],
        packaging_gr: [
          "Πλήρωση σε κύπελλο (single, family pack, multipack)",
          "Εναλλακτικά formats: pouch ή bag",
          "Κάλυψη με foil seal ή καπάκι",
          "Ετικετοποίηση, ημερομηνία παραγωγής και lot",
          "Εφαρμογή topping ή granola",
          "Δευτερογενής συσκευασία σε δίσκο, κιβώτιο ή wrap-around"
        ],
        packaging_en: [
          "Cup filling (single, family pack, multipack)",
          "Alternative formats: pouch or bag",
          "Foil sealing or plastic lids",
          "Labeling, date coding, and traceability",
          "Topping or granola application",
          "Secondary packaging: trays, cartons, wrap-around solutions"
        ],
        automation_gr: [
          "Ρομποτικός εγκιβωτισμός και grouping multipack",
          "Παλετοποίηση / αποπαλετοποίηση με προκαθορισμένα patterns",
          "Μεταφορικά συστήματα, buffer zones και συγχρονισμός γραμμών",
          "SCADA/MES διασύνδεση και OEE dashboards"
        ],
        automation_en: [
          "Robotic case packing and multipack grouping",
          "Palletizing / depalletizing with predefined pattern libraries",
          "Conveying systems, buffer zones, and line synchronization",
          "SCADA/MES integration and OEE dashboards"
        ],
        lab_gr: [
          "Παροχή εργαστηριακού εξοπλισμού & in-line για αυτοματοποιημένη ανάλυση και έλεγχο ποιότητας σε πραγματικό χρόνο",
          "Ταχεία και αξιόπιστη ανάλυση λίπους, πρωτεΐνης, υγρασίας, ολικών στερεών, στερεών άνευ λίπους",
          "Τεχνική υποστήριξη από εξειδικευμένο προσωπικό"
        ],
        lab_en: [
          "Supply of laboratory & in-line equipment for automated analysis and real-time quality control",
          "Rapid and reliable analysis of fat, protein, moisture, total solids, and solids-not-fat",
          "Technical support from specialized personnel"
        ],
        services_gr: [
          "Σχεδιασμός και διαστασιολόγηση γραμμών",
          "Εγκατάσταση, commissioning και εκπαίδευση",
          "Προληπτική συντήρηση, ανταλλακτικά και απομακρυσμένη υποστήριξη",
          "Βελτιστοποίηση διεργασιών, χρόνων ζύμωσης και energy audits"
        ],
        services_en: [
          "Line design and equipment sizing",
          "Installation, commissioning, and operator training",
          "Preventive maintenance, spare parts & remote support",
          "Process optimization, fermentation control, and energy audits"
        ]
      },
      benefits_gr: [
        "Σταθερή ποιότητα και ομοιομορφία παρτίδων",
        "Ευελιξία για όλους τους τύπους γιαουρτιού και συσκευασίας",
        "Μειωμένες απώλειες και ελεγχόμενοι χρόνοι ζύμωσης",
        "Πλήρως αυτοματοποιημένος και υγιεινός χειρισμός"
      ],
      benefits_en: [
        "Consistent quality and batch uniformity",
        "Flexibility across yogurt types and packaging formats",
        "Reduced losses and controlled fermentation times",
        "Fully automated, hygienic product handling"
      ]
    }
  },
  "dairy-cheese": {
    page_id: "industries-dairy-cheese",
    slug: "/industries/dairy/cheese",
    industry: "Dairy",
    subcategory: "Cheese",
    meta: {
      title_gr: "Λύσεις Επεξεργασίας & Συσκευασίας | TFT",
      title_en: "Processing & Packaging Solutions | TFT",
      description_gr: "Η TFT προσφέρει ολοκληρωμένες λύσεις για την παραγωγή τυριών, καλύπτοντας όλα τα στάδια από την επεξεργασία γάλακτος και την πήξη έως την ωρίμανση, τη συσκευασία και τον τελικό χειρισμό του προϊόντος. Οι γραμμές μας σχεδιάζονται με έμφαση στην υγιεινή, τη σταθερή ποιότητα και την ευελιξία, υποστηρίζοντας ευρύ φάσμα τυριών όπως φρέσκα, ημίσκληρα, σκληρά και άλμης.",
      description_en: "TFT provides integrated solutions for cheese production, covering all stages from milk processing and coagulation to ripening, packaging, and finished product handling. Our lines are designed with a strong focus on hygiene, consistent quality, and flexibility, supporting a wide range of cheeses including fresh, semi-hard, hard, and brined varieties."
    },
    content: {
      intro_gr: "Η TFT προσφέρει ολοκληρωμένες λύσεις για την παραγωγή τυριών, καλύπτοντας όλα τα στάδια από την επεξεργασία γάλακτος και την πήξη έως την ωρίμανση, τη συσκευασία και τον τελικό χειρισμό του προϊόντος. Οι γραμμές μας σχεδιάζονται με έμφαση στην υγιεινή, τη σταθερή ποιότητα και την ευελιξία, υποστηρίζοντας ευρύ φάσμα τυριών όπως φρέσκα, ημίσκληρα, σκληρά και άλμης.",
      intro_en: "TFT provides integrated solutions for cheese production, covering all stages from milk processing and coagulation to ripening, packaging, and finished product handling. Our lines are designed with a strong focus on hygiene, consistent quality, and flexibility, supporting a wide range of cheeses including fresh, semi-hard, hard, and brined varieties.",
      overview_gr: "Η παραγωγή τυριών απαιτεί ακριβή έλεγχο θερμικής επεξεργασίας, πήξης, αποστράγγισης και ωρίμανσης, καθώς και προσαρμογή των διεργασιών στα ιδιαίτερα χαρακτηριστικά κάθε τύπου τυριού. Οι λύσεις της TFT ενσωματώνουν υγιεινό σχεδιασμό, αυτοματισμούς και συστήματα ελέγχου που διασφαλίζουν επαναληψιμότητα διεργασιών και σταθερή ποιότητα προϊόντος.",
      overview_en: "Cheese production requires precise control of thermal processing, coagulation, whey drainage, and ripening conditions, adapted to the specific characteristics of each cheese type. TFT's solutions integrate hygienic design, automation, and advanced control systems to ensure repeatable processes and consistent product quality.",
      solutions: {
        turnkey_gr: "Η TFT αναλαμβάνει τον σχεδιασμό και την υλοποίηση ολοκληρωμένων γραμμών παραγωγής τυριών με το κλειδί στο χέρι. Από τη μελέτη και τη διαστασιολόγηση έως τη θέση σε λειτουργία, λειτουργούμε ως ενιαίος συνεργάτης, εξασφαλίζοντας ομαλή ενσωμάτωση επεξεργασίας, ωρίμανσης, συσκευασίας, αυτοματισμών και ποιοτικού ελέγχου.\n\nΗ turnkey προσέγγιση μειώνει το ρίσκο υλοποίησης και προσφέρει λύσεις σχεδιασμένες για μακροχρόνια λειτουργία και μελλοντική επέκταση.",
        turnkey_en: "TFT designs and delivers complete cheese production lines on a turnkey basis. From engineering and equipment sizing to commissioning, we act as a single point of responsibility, ensuring seamless integration of processing, ripening, packaging, automation, and quality control.\n\nThis approach reduces project risk and delivers solutions designed for long-term operation and future expansion.",
        process_gr: [
          "Προετοιμασία και θερμική επεξεργασία γάλακτος",
          "Προσθήκη καλλιεργειών και πυτιάς",
          "Πήξη, κοπή πήγματος και αποστράγγιση τυρογάλακτος",
          "Διαμόρφωση, καλούπιασμα και πρεσάρισμα",
          "Αλάτισμα (ξηρό ή σε άλμη)",
          "Έλεγχος συνθηκών ωρίμανσης (θερμοκρασία, υγρασία, χρόνος)",
          "CIP/SIP συστήματα για υγιεινή και ελαχιστοποίηση downtime"
        ],
        process_en: [
          "Milk preparation and thermal treatment",
          "Addition of cultures and rennet",
          "Coagulation, curd cutting, and whey drainage",
          "Molding, forming, and pressing",
          "Salting (dry or brine)",
          "Controlled ripening conditions (temperature, humidity, time)",
          "CIP/SIP systems for hygienic operation and minimal downtime"
        ],
        packaging_gr: [
          "Συσκευασία σε vacuum, MAP ή άλμη",
          "Κοπή και portioning",
          "Ετικετοποίηση, ημερομηνία παραγωγής και lot",
          "Δευτερογενής συσκευασία σε κιβώτιο ή δίσκο",
          "Λύσεις για χύδην ή τελικό καταναλωτικό προϊόν"
        ],
        packaging_en: [
          "Vacuum, MAP, or brine packaging",
          "Cutting and portioning",
          "Labeling, date coding, and lot identification",
          "Secondary packaging into trays or cases",
          "Solutions for bulk or consumer-ready products"
        ],
        automation_gr: [
          "Αυτοματοποιημένη κοπή, ταξινόμηση και ομαδοποίηση",
          "Ρομποτικός εγκιβωτισμός και παλετοποίηση",
          "Μεταφορικά συστήματα και buffer zones",
          "SCADA/MES διασύνδεση για έλεγχο διεργασιών και ιχνηλασιμότητα",
          "OEE dashboards για παρακολούθηση απόδοσης"
        ],
        automation_en: [
          "Automated cutting, sorting, and grouping",
          "Robotic case packing and palletizing",
          "Conveying systems and buffer zones",
          "SCADA/MES integration for process control and traceability",
          "OEE dashboards for performance monitoring"
        ],
        lab_gr: [
          "Παροχή εργαστηριακού εξοπλισμού για αυτοματοποιημένη ανάλυση και έλεγχο ποιότητας σε πραγματικό χρόνο",
          "Ταχεία και αξιόπιστη ανάλυση λίπους, υγρασίας, πρωτεΐνης",
          "Τεχνική υποστήριξη από εξειδικευμένο προσωπικό"
        ],
        lab_en: [
          "Supply of laboratory equipment for automated analysis and real-time quality control",
          "Rapid and reliable analysis of fat, moisture, and protein",
          "Technical support from specialized personnel"
        ],
        services_gr: [
          "Μελέτη και διαστασιολόγηση γραμμών τυροκομίας",
          "Εγκατάσταση, commissioning και εκπαίδευση προσωπικού",
          "Προληπτική συντήρηση, ανταλλακτικά και απομακρυσμένη υποστήριξη",
          "Βελτιστοποίηση διεργασιών και ενεργειακή αξιολόγηση"
        ],
        services_en: [
          "Cheese line engineering and equipment sizing",
          "Installation, commissioning, and operator training",
          "Preventive maintenance, spare parts & remote support",
          "Process optimization and energy efficiency assessment"
        ]
      },
      benefits_gr: [
        "Σταθερή ποιότητα και επαναληψιμότητα παρτίδων",
        "Ευελιξία για διαφορετικούς τύπους τυριών και formats",
        "Ελεγχόμενη ωρίμανση και μειωμένες απώλειες",
        "Υγιεινός, αυτοματοποιημένος και ασφαλής χειρισμός προϊόντος"
      ],
      benefits_en: [
        "Consistent quality and batch repeatability",
        "Flexibility across different cheese types and formats",
        "Controlled ripening with reduced product losses",
        "Hygienic, automated, and safe product handling"
      ]
    }
  },
  "dairy-butter": {
    page_id: "industries-dairy-butter",
    slug: "/industries/dairy/butter",
    industry: "Dairy",
    subcategory: "Butter",
    meta: {
      title_gr: "Λύσεις Επεξεργασίας & Συσκευασίας | TFT",
      title_en: "Processing & Packaging Solutions | TFT",
      description_gr: "Η TFT προσφέρει ολοκληρωμένες λύσεις για την παραγωγή και συσκευασία βουτύρου, καλύπτοντας όλα τα στάδια από την επεξεργασία κρέμας έως τη μορφοποίηση, τη συσκευασία και τον τελικό χειρισμό του προϊόντος. Οι γραμμές μας σχεδιάζονται με έμφαση στη σταθερή ποιότητα, την υφή, τη γεύση και την υγιεινή, υποστηρίζοντας τόσο βιομηχανικές όσο και εξειδικευμένες εφαρμογές.",
      description_en: "TFT provides integrated solutions for butter production and packaging, covering all stages from cream processing to forming, packaging, and finished product handling. Our lines are designed with a strong focus on consistent quality, texture, flavor, and hygienic operation, supporting both industrial and specialized applications."
    },
    content: {
      intro_gr: "Η TFT προσφέρει ολοκληρωμένες λύσεις για την παραγωγή και συσκευασία βουτύρου, καλύπτοντας όλα τα στάδια από την επεξεργασία κρέμας έως τη μορφοποίηση, τη συσκευασία και τον τελικό χειρισμό του προϊόντος. Οι γραμμές μας σχεδιάζονται με έμφαση στη σταθερή ποιότητα, την υφή, τη γεύση και την υγιεινή, υποστηρίζοντας τόσο βιομηχανικές όσο και εξειδικευμένες εφαρμογές.",
      intro_en: "TFT provides integrated solutions for butter production and packaging, covering all stages from cream processing to forming, packaging, and finished product handling. Our lines are designed with a strong focus on consistent quality, texture, flavor, and hygienic operation, supporting both industrial and specialized applications.",
      overview_gr: "Η παραγωγή βουτύρου απαιτεί ακριβή έλεγχο της σύστασης της κρέμας, της μηχανικής κατεργασίας και της θερμοκρασίας, παράγοντες που καθορίζουν τη δομή, την πλαστικότητα και τη σταθερότητα του τελικού προϊόντος. Οι λύσεις της TFT ενσωματώνουν υγιεινό σχεδιασμό, αυτοματισμούς και συστήματα ελέγχου που διασφαλίζουν επαναληψιμότητα διεργασιών και σταθερή ποιότητα παρτίδων.",
      overview_en: "Butter production requires precise control of cream composition, mechanical processing, and temperature, all of which define the structure, plasticity, and stability of the final product. TFT's solutions integrate hygienic design, automation, and advanced control systems to ensure repeatable processes and consistent batch quality.",
      solutions: {
        turnkey_gr: "Η TFT αναλαμβάνει τον σχεδιασμό και την υλοποίηση ολοκληρωμένων γραμμών παραγωγής βουτύρου με το κλειδί στο χέρι. Από τη μελέτη και τη διαστασιολόγηση έως τη θέση σε λειτουργία, λειτουργούμε ως ενιαίος συνεργάτης, εξασφαλίζοντας ομαλή ενσωμάτωση επεξεργασίας, μορφοποίησης, συσκευασίας, αυτοματισμών και ποιοτικού ελέγχου.\n\nΗ turnkey προσέγγιση μειώνει το ρίσκο υλοποίησης και προσφέρει λύσεις σχεδιασμένες για μακροχρόνια λειτουργία και μελλοντική επέκταση.",
        turnkey_en: "TFT designs and delivers complete butter production lines on a turnkey basis. From engineering and equipment sizing to commissioning, we act as a single point of responsibility, ensuring seamless integration of processing, forming, packaging, automation, and quality control.\n\nThis approach reduces project risk and delivers solutions designed for long-term operation and future expansion.",
        process_gr: [
          "Παραλαβή και προετοιμασία κρέμας",
          "Θερμική επεξεργασία και ρύθμιση λιποπεριεκτικότητας",
          "Μηχανική κατεργασία (churning) και διαχωρισμός βουτύρου / βουτυρογάλακτος",
          "Πλύση και ζύμωση βουτύρου",
          "Ρύθμιση υγρασίας και αλατότητας",
          "Έλεγχος θερμοκρασίας για σωστή υφή και πλαστικότητα",
          "CIP/SIP συστήματα για υγιεινή λειτουργία και ελαχιστοποίηση downtime"
        ],
        process_en: [
          "Cream reception and preparation",
          "Thermal treatment and fat standardization",
          "Mechanical churning and separation of butter and buttermilk",
          "Butter washing and working",
          "Moisture and salt adjustment",
          "Temperature control for texture and plasticity",
          "CIP/SIP systems for hygienic operation and minimal downtime"
        ],
        packaging_gr: [
          "Μορφοποίηση και κοπή σε μπλοκ ή μερίδες",
          "Συσκευασία σε foil, χαρτί ή σύνθετα υλικά",
          "Cylindrical ή rectangular formats (consumer & foodservice)",
          "Ετικετοποίηση, ημερομηνία παραγωγής και lot",
          "Δευτερογενής συσκευασία σε κιβώτια ή δίσκους"
        ],
        packaging_en: [
          "Forming and cutting into blocks or portions",
          "Packaging in foil, paper, or composite materials",
          "Cylindrical or rectangular formats (consumer & foodservice)",
          "Labeling, date coding, and lot identification",
          "Secondary packaging into trays or cases"
        ],
        automation_gr: [
          "Αυτοματοποιημένη μορφοποίηση, κοπή και ομαδοποίηση",
          "Ρομποτικός εγκιβωτισμός και παλετοποίηση",
          "Μεταφορικά συστήματα και buffer zones",
          "SCADA/MES διασύνδεση για έλεγχο διεργασιών και ιχνηλασιμότητα",
          "OEE dashboards για συνεχή παρακολούθηση απόδοσης"
        ],
        automation_en: [
          "Automated forming, cutting, and grouping",
          "Robotic case packing and palletizing",
          "Conveying systems and buffer zones",
          "SCADA/MES integration for process control and traceability",
          "OEE dashboards for performance monitoring"
        ],
        lab_gr: [
          "Παροχή εργαστηριακού εξοπλισμού & in-line για αυτοματοποιημένη ανάλυση και έλεγχο ποιότητας σε πραγματικό χρόνο",
          "Ταχεία και αξιόπιστη ανάλυση λίπους, πρωτεΐνης, υγρασίας, ολικών στερεών, στερεών άνευ λίπους",
          "Τεχνική υποστήριξη από εξειδικευμένο προσωπικό"
        ],
        lab_en: [
          "Supply of laboratory & in-line equipment for automated analysis and real-time quality control",
          "Rapid and reliable analysis of fat, protein, moisture, total solids, and solids-not-fat",
          "Technical support from specialized personnel"
        ],
        services_gr: [
          "Μελέτη και διαστασιολόγηση γραμμών βουτύρου",
          "Εγκατάσταση, commissioning και εκπαίδευση προσωπικού",
          "Προληπτική συντήρηση, ανταλλακτικά και απομακρυσμένη υποστήριξη",
          "Βελτιστοποίηση διεργασιών και ενεργειακή αξιολόγηση"
        ],
        services_en: [
          "Butter line engineering and equipment sizing",
          "Installation, commissioning, and operator training",
          "Preventive maintenance, spare parts & remote support",
          "Process optimization and energy efficiency assessment"
        ]
      },
      benefits_gr: [
        "Σταθερή ποιότητα, υφή και γεύση προϊόντος",
        "Ακριβής έλεγχος υγρασίας και λιποπεριεκτικότητας",
        "Ευελιξία σε formats και εφαρμογές (consumer & foodservice)",
        "Υγιεινός, αυτοματοποιημένος και ασφαλής χειρισμός"
      ],
      benefits_en: [
        "Consistent product quality, texture, and flavor",
        "Precise control of moisture and fat content",
        "Flexibility across formats and applications",
        "Hygienic, automated, and safe product handling"
      ]
    }
  },
  "dairy-ice-cream": {
    page_id: "industries-dairy-ice-cream",
    slug: "/industries/dairy/ice-cream",
    industry: "Dairy",
    subcategory: "Ice Cream",
    meta: {
      title_gr: "Παγωτό | Λύσεις Επεξεργασίας & Συσκευασίας | TFT",
      title_en: "Ice Cream | Processing & Packaging Solutions | TFT",
      description_gr: "Η TFT προσφέρει ολοκληρωμένες λύσεις για την παραγωγή παγωτού, καλύπτοντας όλα τα στάδια από την προετοιμασία του μίγματος έως την κατάψυξη, τη μορφοποίηση, τη συσκευασία και τον τελικό χειρισμό του προϊόντος.",
      description_en: "TFT provides integrated solutions for ice cream production, covering all stages from mix preparation to freezing, forming, packaging, and finished product handling."
    },
    content: {
      intro_gr: "Η TFT προσφέρει ολοκληρωμένες λύσεις για την παραγωγή παγωτού, καλύπτοντας όλα τα στάδια από την προετοιμασία του μίγματος έως την κατάψυξη, τη μορφοποίηση, τη συσκευασία και τον τελικό χειρισμό του προϊόντος. Οι γραμμές μας σχεδιάζονται με έμφαση στη σταθερή ποιότητα, τη δομή, την υφή και τον έλεγχο της θερμοκρασίας, υποστηρίζοντας ευρύ φάσμα προϊόντων και formats.",
      intro_en: "TFT provides integrated solutions for ice cream production, covering all stages from mix preparation to freezing, forming, packaging, and finished product handling. Our lines are designed with a strong focus on consistent quality, structure, texture, and temperature control, supporting a wide range of products and formats.",
      overview_gr: "Η παραγωγή παγωτού απαιτεί ακριβή έλεγχο θερμικής επεξεργασίας, ανάμιξης, κατάψυξης και ενσωμάτωσης αέρα (overrun), καθώς και σταθερή διαχείριση της ψυκτικής αλυσίδας. Οι λύσεις της TFT ενσωματώνουν υγιεινό σχεδιασμό, προηγμένους αυτοματισμούς και συστήματα ελέγχου, διασφαλίζοντας επαναληψιμότητα διεργασιών και σταθερή ποιότητα προϊόντος.",
      overview_en: "Ice cream production requires precise control of thermal processing, mixing, freezing, air incorporation (overrun), and cold chain management. TFT's solutions integrate hygienic design, advanced automation, and control systems to ensure repeatable processes and stable product quality.",
      solutions: {
        turnkey_gr: "Η TFT αναλαμβάνει τον σχεδιασμό και την υλοποίηση ολοκληρωμένων γραμμών παραγωγής παγωτού με το κλειδί στο χέρι. Από τη μελέτη και τη διαστασιολόγηση έως τη θέση σε λειτουργία, λειτουργούμε ως ενιαίος συνεργάτης, εξασφαλίζοντας ομαλή ενσωμάτωση επεξεργασίας, κατάψυξης, μορφοποίησης, συσκευασίας, αυτοματισμών και ποιοτικού ελέγχου.\n\nΗ turnkey προσέγγιση μειώνει το ρίσκο υλοποίησης και προσφέρει λύσεις σχεδιασμένες για αξιόπιστη λειτουργία και μελλοντική ανάπτυξη.",
        turnkey_en: "TFT designs and delivers complete ice cream production lines on a turnkey basis. From engineering and equipment sizing to commissioning, we act as a single point of responsibility, ensuring seamless integration of processing, freezing, forming, packaging, automation, and quality control.\n\nThis approach reduces project risk and delivers solutions designed for reliable operation and future scalability.",
        process_gr: [
          "Προετοιμασία και τυποποίηση μίγματος παγωτού",
          "Θερμική επεξεργασία και ομογενοποίηση",
          "Ωρίμανση μίγματος (aging)",
          "Κατάψυξη και έλεγχος overrun",
          "Ενσωμάτωση inclusions (σοκολάτα, ξηροί καρποί, σιρόπια)",
          "Έλεγχος θερμοκρασίας και υφής",
          "CIP/SIP συστήματα για υγιεινή λειτουργία και ελαχιστοποίηση downtime"
        ],
        process_en: [
          "Ice cream mix preparation and standardization",
          "Thermal processing and homogenization",
          "Mix aging",
          "Freezing and overrun control",
          "Inclusion dosing (chocolate, nuts, syrups)",
          "Texture and temperature control",
          "CIP/SIP systems for hygienic operation and minimal downtime"
        ],
        packaging_gr: [
          "Εξώθηση ή πλήρωση σε κύπελλο, χωνάκι ή καλούπι",
          "Παραγωγή stick, sandwich ή bulk προϊόντων",
          "Συσκευασία σε consumer και foodservice formats",
          "Ετικετοποίηση, ημερομηνία παραγωγής και lot",
          "Δευτερογενής συσκευασία σε κιβώτια ή δίσκους"
        ],
        packaging_en: [
          "Extrusion or filling into cups, cones, or molds",
          "Production of stick, sandwich, or bulk products",
          "Packaging for consumer and foodservice formats",
          "Labeling, date coding, and lot identification",
          "Secondary packaging into trays or cases"
        ],
        automation_gr: [
          "Αυτοματοποιημένη μορφοποίηση και ομαδοποίηση προϊόντων",
          "Ρομποτικός εγκιβωτισμός και παλετοποίηση",
          "Μεταφορικά συστήματα κατάλληλα για χαμηλές θερμοκρασίες",
          "Buffer zones και συγχρονισμός γραμμών",
          "SCADA/MES διασύνδεση και OEE dashboards"
        ],
        automation_en: [
          "Automated forming and product grouping",
          "Robotic case packing and palletizing",
          "Conveying systems suitable for low-temperature environments",
          "Buffer zones and line synchronization",
          "SCADA/MES integration and OEE dashboards"
        ],
        lab_gr: [
          "Παροχή εργαστηριακού εξοπλισμού για αυτοματοποιημένη ανάλυση και έλεγχο ποιότητας σε πραγματικό χρόνο",
          "Ταχεία και αξιόπιστη ανάλυση λίπους, πρωτεΐνης",
          "Τεχνική υποστήριξη από εξειδικευμένο προσωπικό"
        ],
        lab_en: [
          "Supply of laboratory equipment for automated analysis and real-time quality control",
          "Rapid and reliable analysis of fat and protein",
          "Technical support from specialized personnel"
        ],
        services_gr: [
          "Μελέτη και διαστασιολόγηση γραμμών παγωτού",
          "Εγκατάσταση, commissioning και εκπαίδευση προσωπικού",
          "Προληπτική συντήρηση, ανταλλακτικά και απομακρυσμένη υποστήριξη",
          "Βελτιστοποίηση συνταγών, overrun και ενεργειακή αξιολόγηση"
        ],
        services_en: [
          "Ice cream line engineering and equipment sizing",
          "Installation, commissioning, and operator training",
          "Preventive maintenance, spare parts & remote support",
          "Recipe optimization, overrun control, and energy efficiency assessment"
        ]
      },
      benefits_gr: [
        "Σταθερή υφή, δομή και ποιότητα προϊόντος",
        "Ακριβής έλεγχος θερμοκρασίας και overrun",
        "Ευελιξία σε προϊόντα, inclusions και formats",
        "Αξιόπιστη ψυκτική αλυσίδα και αυτοματοποιημένος χειρισμός"
      ],
      benefits_en: [
        "Consistent product texture, structure, and quality",
        "Precise control of temperature and overrun",
        "Flexibility across products, inclusions, and formats",
        "Reliable cold chain and automated product handling"
      ]
    }
  },
  "beverage-water": {
    page_id: "industries-beverages-water",
    slug: "/industries/beverage/water",
    industry: "Beverages",
    subcategory: "Water",
    meta: {
      title_gr: "Νερό | Γραμμές Επεξεργασίας & Εμφιάλωσης | TFT",
      title_en: "Water | Processing & Bottling Lines | TFT",
      description_gr: "Ολοκληρωμένες λύσεις TFT για επεξεργασία, εμφιάλωση και δευτερογενή συσκευασία νερού — still & sparkling — με έμφαση στην υγιεινή, την αποδοτικότητα και την ποιότητα.",
      description_en: "Complete TFT solutions for water treatment, bottling and secondary packaging — still & sparkling — focused on hygiene, efficiency and product quality."
    },
    content: {
      intro_gr: "Η TFT σχεδιάζει και υλοποιεί πλήρεις γραμμές για εμφιάλωση νερού (ακίνητο και ανθρακούχο), από την προεπεξεργασία και σταθεροποίηση έως το blowing της φιάλης, την πλήρωση, την ετικετοποίηση και το end-of-line. Οι λύσεις μας διασφαλίζουν σταθερή ποιότητα, χαμηλή κατανάλωση πόρων και ευελιξία σε formats και χωρητικότητες.",
      intro_en: "TFT delivers end-to-end lines for still and sparkling water, from pretreatment and stabilization to bottle blowing, filling, labeling and end-of-line. Our solutions ensure consistent quality, low resource consumption, and flexibility across formats and capacities.",
      solutions: {
        process_gr: [
          "Προεπεξεργασία: φίλτρανση, ενεργός άνθρακας, αποσιδήρωση/απονικέλωση όπου απαιτείται",
          "Αντίστροφη όσμωση/απιονισμός και ρύθμιση αγωγιμότητας κατά προδιαγραφές",
          "UV απολύμανση ή/και όζον για σταθερότητα και μικροβιολογική ασφάλεια",
          "Επαναμεταλλικοποίηση (remineralization) και σταθεροποίηση γεύσης",
          "Ανθράκωση (carbonation) για sparkling νερό με ακριβή έλεγχο CO₂",
          "CIP/SIP και υγιεινός σχεδιασμός δεξαμενών & σωληνώσεων"
        ],
        process_en: [
          "Pretreatment: filtration, activated carbon, iron/nickel removal where required",
          "Reverse osmosis/deionization and conductivity adjustment per specifications",
          "UV disinfection and/or ozone for stability and microbiological safety",
          "Remineralization and flavor stabilization",
          "Carbonation for sparkling water with precise CO₂ control",
          "CIP/SIP and hygienic design of tanks & piping"
        ],
        packaging_gr: [
          "Χάρτινη πολυστρωματική συσκευασία (Gable Top/Roll-Fed), blow-molding PET (SBO) ή χρήση HDPE/γυάλινων φιαλών ανά ανάγκη",
          "Πλύση/έκπλυση, aseptic ή ultra-clean πλήρωση και καπάκωμα",
          "Ετικετοποίηση (wrap-around, sleeve, self-adhesive) και inkjet/laser coding",
          "Δευτερογενής συσκευασία: shrink bundle, tray, wrap-around carton",
          "Έλεγχοι in-line: στάθμης, διαρροής, ροπής καπακιού, βάρους"
        ],
        packaging_en: [
          "PET blow-molding (SBO) or use of HDPE/glass bottles as needed",
          "Rinsing, aseptic or ultra-clean filling and capping",
          "Labeling (wrap-around, sleeve, self-adhesive) and inkjet/laser coding",
          "Secondary packaging: shrink bundle, tray, wrap-around carton",
          "In-line checks: level, leak, cap torque, weight"
        ],
        automation_gr: [
          "Μεταφορικές γραμμές PET/γυάλινων, accumulation & buffer systems",
          "Ρομποτικός εγκιβωτισμός (case/pack) και παλετοποίηση με pattern library",
          "Αυτόματες αλλαγές format (quick changeovers) και συγχρονισμός γραμμής",
          "SCADA/MES integration για OEE, ιχνηλασιμότητα και ενεργειακή παρακολούθηση"
        ],
        automation_en: [
          "PET/glass conveyor lines, accumulation & buffer systems",
          "Robotic case packing and palletizing with pattern library",
          "Automatic format changes (quick changeovers) and line synchronization",
          "SCADA/MES integration for OEE, traceability and energy monitoring"
        ],
        lab_gr: [
          "Παράμετροι ποιότητας: αγωγιμότητα, θολότητα (NTU), pH, TOC",
          "Εξοπλισμός και αντιδραστήρια μικροβιολογικού ελέγχου"
        ],
        lab_en: [
          "Quality parameters: conductivity, turbidity (NTU), pH, TOC",
          "Equipment and reagents for microbiological control"
        ],
        services_gr: [
          "Μελέτη ποιότητας πηγής/δικτύου και επιλογή κατάλληλης επεξεργασίας",
          "Layout γραμμής, εγκατάσταση, commissioning και εκπαίδευση",
          "Προληπτική συντήρηση, ανταλλακτικά και απομακρυσμένη υποστήριξη",
          "Βελτιστοποίηση κατανάλωσης νερού/ενέργειας και μείωση απωλειών"
        ],
        services_en: [
          "Source/network quality study and appropriate treatment selection",
          "Line layout, installation, commissioning and training",
          "Preventive maintenance, spare parts and remote support",
          "Water/energy consumption optimization and loss reduction"
        ]
      },
      benefits_gr: [
        "Σταθερή ποιότητα και μικροβιολογική ασφάλεια προϊόντος",
        "Υψηλή διαθεσιμότητα γραμμής με γρήγορες αλλαγές format",
        "Χαμηλή κατανάλωση νερού και ενέργειας, μειωμένο λειτουργικό κόστος",
        "Ευελιξία σε υλικά, τύπους και μεγέθη συσκευασιών (Carton Gable Top/Roll-Fed, PET, HDPE, Glass) και σε still/sparkling"
      ],
      benefits_en: [
        "Consistent product quality and microbiological safety",
        "High line availability with fast format changeovers",
        "Low water and energy consumption, reduced operating cost",
        "Flexibility across bottle materials/sizes (PET, glass, HDPE) and still/sparkling"
      ]
    }
  },
  "meat-fish-eggs-meat-fish": {
    page_id: "industries-meat-fish-eggs-meat-fish",
    slug: "/industries/meat-fish-eggs/meat-fish",
    industry: "Meat, Fish & Eggs",
    subcategory: "Meat & Fish",
    meta: {
      title_gr: "Κρέας & Ψάρι | Λύσεις Συσκευασίας & Ποιοτικού Ελέγχου | TFT",
      title_en: "Meat & Fish | Packaging & Quality Control Solutions | TFT",
      description_gr: "Ολοκληρωμένες λύσεις TFT για συσκευασία και ποιοτικό έλεγχο κρέατος και ψαριού — MAP, vacuum, thermoforming — με έμφαση στην ασφάλεια, τη φρεσκάδα και την ιχνηλασιμότητα.",
      description_en: "Complete TFT solutions for meat and fish packaging and quality control — MAP, vacuum, thermoforming — focusing on safety, freshness, and traceability."
    },
    content: {
      intro_gr: "Η TFT προσφέρει ολοκληρωμένες λύσεις συσκευασίας για κρέας και ψάρι, από το φρέσκο προϊόν έως τα επεξεργασμένα και μαγειρεμένα τρόφιμα. Οι γραμμές μας σχεδιάζονται με γνώμονα την ασφάλεια τροφίμων, την παράταση της διάρκειας ζωής, την ελαχιστοποίηση απωλειών και την πλήρη ιχνηλασιμότητα.",
      intro_en: "TFT provides complete packaging solutions for meat and fish, from fresh products to processed and cooked foods. Our lines are designed for food safety, shelf-life extension, waste minimization, and full traceability.",
      solutions: {
        process_gr: [
          "Παραλαβή και προετοιμασία πρώτης ύλης με έλεγχο θερμοκρασίας",
          "Κοπή, φιλέτισμα και μερισμός σε portions",
          "Μαρινάρισμα, seasoning και επεξεργασία",
          "Θερμική επεξεργασία: ψήσιμο, βρασμός, pasteurization",
          "Γρήγορη ψύξη (blast chilling) για διατήρηση ποιότητας",
          "Κατάψυξη (IQF - Individual Quick Freezing)",
          "Υγιεινός χειρισμός με HACCP compliance"
        ],
        process_en: [
          "Raw material reception and preparation with temperature control",
          "Cutting, filleting and portioning",
          "Marinating, seasoning and processing",
          "Thermal processing: roasting, cooking, pasteurization",
          "Blast chilling for quality preservation",
          "Freezing (IQF - Individual Quick Freezing)",
          "Hygienic handling with HACCP compliance"
        ],
        packaging_gr: [
          "Thermoforming με vacuum ή MAP (Modified Atmosphere Packaging)",
          "Tray sealing για φρέσκο κρέας και ψάρι",
          "Vacuum packaging για επεξεργασμένα προϊόντα",
          "Skin packaging για premium presentation",
          "Ζυγομέτρηση και αυτόματη τιμολόγηση",
          "Ετικετοποίηση με θρεπτικές πληροφορίες και barcode",
          "Δευτερογενής συσκευασία: κιβώτια με έλεγχο θερμοκρασίας"
        ],
        packaging_en: [
          "Thermoforming with vacuum or MAP (Modified Atmosphere Packaging)",
          "Tray sealing for fresh meat and fish",
          "Vacuum packaging for processed products",
          "Skin packaging for premium presentation",
          "Weighing and automatic pricing",
          "Labeling with nutritional information and barcode",
          "Secondary packaging: temperature-controlled boxes"
        ],
        automation_gr: [
          "Ρομποτικός χειρισμός portions και συσκευασιών",
          "Αυτόματη παλετοποίηση με ψυκτικά patterns",
          "X-ray και μεταλλοανίχνευση για ασφάλεια προϊόντος",
          "Vision systems για έλεγχο ποιότητας και foreign objects",
          "Traceability από αγρόκτημα/αλιεία έως καταναλωτή"
        ],
        automation_en: [
          "Robotic handling of portions and packages",
          "Automatic palletizing with refrigerated patterns",
          "X-ray and metal detection for product safety",
          "Vision systems for quality control and foreign objects",
          "Traceability from farm/fishery to consumer"
        ],
        lab_gr: [
          "DNA testing για γνησιότητα (meat authenticity)",
          "Εξοπλισμός και αντιδραστήρια μικροβιολογικού ελέγχου παθογόνων μικροοργανισμών",
          "Εξοπλισμός εργαστηρίου χημικών αναλύσεων σύστασης (λίπος, πρωτεΐνη, υγρασία, κολλαγόνο, κα)",
          "Αυτόματοι αναλυτές NIR για τη σύσταση του κρέατος και τη λήψη διατροφικής ετικέτας",
          "X-ray αναλυτές κρέατος",
          "Τεχνική υποστήριξη από εξειδικευμένο προσωπικό"
        ],
        lab_en: [
          "DNA testing for meat authenticity",
          "Equipment and reagents for pathogen microbiological control",
          "Laboratory equipment for chemical composition analysis (fat, protein, moisture, collagen, etc.)",
          "NIR automatic analyzers for meat composition and nutritional labeling",
          "X-ray meat analyzers",
          "Technical support from specialized personnel"
        ],
        services_gr: [
          "Σχεδιασμός γραμμής συσκευασίας και cold chain",
          "Εγκατάσταση, commissioning και εκπαίδευση",
          "Προγράμματα συντήρησης και ανταλλακτικά"
        ],
        services_en: [
          "Packaging line and cold chain design",
          "Installation, commissioning and training",
          "Maintenance programs and spare parts"
        ]
      },
      benefits_gr: [
        "Παράταση διάρκειας ζωής με MAP και vacuum τεχνολογία",
        "Μείωση απωλειών και food waste",
        "Πλήρης ιχνηλασιμότητα και food safety compliance",
        "Ευελιξία για φρέσκα, επεξεργασμένα και κατεψυγμένα προϊόντα"
      ],
      benefits_en: [
        "Shelf-life extension with MAP and vacuum technology",
        "Reduced losses and food waste",
        "Full traceability and food safety compliance",
        "Flexibility for fresh, processed and frozen products"
      ]
    }
  },
  "meat-fish-eggs-eggs": {
    page_id: "industries-meat-fish-eggs-eggs",
    slug: "/industries/meat-fish-eggs/eggs",
    industry: "Meat, Fish & Eggs",
    subcategory: "Eggs",
    meta: {
      title_gr: "Αυγά | Λύσεις Συσκευασίας & Ποιοτικού Ελέγχου | TFT",
      title_en: "Eggs | Packaging & Quality Control Solutions | TFT",
      description_gr: "Ολοκληρωμένες λύσεις TFT για χειρισμό, ταξινόμηση και συσκευασία αυγών — από το grading έως την παλετοποίηση — με έμφαση στην προστασία, την ποιότητα και την αποδοτικότητα.",
      description_en: "Complete TFT solutions for egg handling, grading, and packaging — from grading to palletizing — focusing on protection, quality, and efficiency."
    },
    content: {
      intro_gr: "Η TFT σχεδιάζει και υλοποιεί ολοκληρωμένες γραμμές για τη συλλογή, τον έλεγχο, την ταξινόμηση και τη συσκευασία αυγών. Οι λύσεις μας εξασφαλίζουν απαλό χειρισμό, ακριβή ταξινόμηση κατά βάρος/ποιότητα και ασφαλή μεταφορά στον καταναλωτή.",
      intro_en: "TFT designs and implements complete lines for egg collection, inspection, grading, and packaging. Our solutions ensure gentle handling, precise weight/quality grading, and safe delivery to consumers.",
      solutions: {
        process_gr: [
          "Συλλογή αυγών από κλωβούς ή free-range συστήματα",
          "Απαλή μεταφορά με conveyor belts",
          "Πλύσιμο και απολύμανση με ελεγχόμενη θερμοκρασία",
          "Στέγνωμα με ζεστό αέρα",
          "Candling (διαφάνεια) για έλεγχο εσωτερικής ποιότητας",
          "Grading: ταξινόμηση κατά βάρος (S, M, L, XL)",
          "Διαχωρισμός ελαττωματικών αυγών"
        ],
        process_en: [
          "Egg collection from cages or free-range systems",
          "Gentle transport with conveyor belts",
          "Washing and sanitization at controlled temperature",
          "Drying with warm air",
          "Candling for internal quality inspection",
          "Grading: weight classification (S, M, L, XL)",
          "Defective egg separation"
        ],
        packaging_gr: [
          "Αυτόματη τοποθέτηση σε χάρτινα ή πλαστικά trays",
          "Συσκευασία σε κιβώτια (6, 10, 12, 30 τεμάχια)",
          "Χάρτινη πολυστρωματική συσκευασία Gable Top (aseptic/non-aseptic) για liquid eggs",
          "Ετικετοποίηση με ημερομηνία, batch και farm info",
          "Barcode/QR code για ιχνηλασιμότητα",
          "Δευτερογενής συσκευασία: χαρτοκιβώτια master boxes, carton wrap-around (για liquid eggs)",
          "Ειδικά pallets για ασφαλή μεταφορά"
        ],
        packaging_en: [
          "Automatic placement in cardboard or plastic trays",
          "Packaging in boxes (6, 10, 12, 30 pieces)",
          "Labeling with date, batch and farm info",
          "Barcode/QR code for traceability",
          "Secondary packaging: master box cartons",
          "Special pallets for safe transport"
        ],
        automation_gr: [
          "High-speed grading μηχανές (έως 180,000 αυγά/ώρα)",
          "Vision systems για crack detection και ποιότητα κελύφους",
          "Ρομποτικός εγκιβωτισμός για πολλαπλά formats",
          "Αυτόματη παλετοποίηση με stable patterns",
          "MES integration για πλήρη ιχνηλασιμότητα farm-to-fork"
        ],
        automation_en: [
          "High-speed grading machines (up to 180,000 eggs/hour)",
          "Vision systems for crack detection and shell quality",
          "Robotic case packing for multiple formats",
          "Automatic palletizing with stable patterns",
          "MES integration for full farm-to-fork traceability"
        ],
        lab_gr: [
          "Εξοπλισμός και αντιδραστήρια μικροβιολογικού ελέγχου παθογόνων μικροοργανισμών",
          "Εξοπλισμός εργαστηρίου χημικών αναλύσεων σύστασης (λίπος, πρωτεΐνη, υγρασία, κολλαγόνο, κα)",
          "Τεχνική υποστήριξη από εξειδικευμένο προσωπικό"
        ],
        lab_en: [
          "Equipment and reagents for pathogen microbiological control",
          "Laboratory equipment for chemical composition analysis (fat, protein, moisture, collagen, etc.)",
          "Technical support from specialized personnel"
        ],
        services_gr: [
          "Σχεδιασμός αυγοτροφείου και grading center",
          "Εγκατάσταση, commissioning και operator training",
          "Συμβόλαια συντήρησης και απομακρυσμένη διάγνωση",
          "Βελτιστοποίηση throughput και μείωση breakage"
        ],
        services_en: [
          "Egg farm and grading center design",
          "Installation, commissioning and operator training",
          "Maintenance contracts and remote diagnostics",
          "Throughput optimization and breakage reduction"
        ]
      },
      benefits_gr: [
        "Υψηλή ταχύτητα επεξεργασίας με ελάχιστο breakage",
        "Ακριβής ταξινόμηση και σταθερή ποιότητα",
        "Πλήρης ιχνηλασιμότητα από αγρόκτημα σε ράφι",
        "Ευελιξία για διαφορετικά formats και markets"
      ],
      benefits_en: [
        "High processing speed with minimal breakage",
        "Precise grading and consistent quality",
        "Full traceability from farm to shelf",
        "Flexibility for different formats and markets"
      ]
    }
  },
  "oils-fats-oils": {
    page_id: "industries-oils-fats-oils",
    slug: "/industries/oils-fats/oils",
    industry: "Oils & Fats",
    subcategory: "Oils",
    meta: {
      title_gr: "Έλαια | Λύσεις Επεξεργασίας & Συσκευασίας | TFT",
      title_en: "Oils | Processing & Packaging Solutions | TFT",
      description_gr: "Ολοκληρωμένες λύσεις TFT για εξαγωγή, διύλιση και συσκευασία φυτικών ελαίων — από το σπόρο/καρπό έως το μπουκάλι — με έμφαση στην ποιότητα, την καθαρότητα και την απόδοση.",
      description_en: "Complete TFT solutions for extraction, refining, and packaging of vegetable oils — from seed/fruit to bottle — focusing on quality, purity, and yield."
    },
    content: {
      intro_gr: "Η TFT προσφέρει ολοκληρωμένες λύσεις για όλα τα στάδια παραγωγής φυτικών ελαίων, από την εξαγωγή και τη διύλιση έως την πλήρωση και την παλετοποίηση. Σχεδιάζουμε με γνώμονα τη διατήρηση των οργανοληπτικών χαρακτηριστικών, την ελαχιστοποίηση απωλειών και τη μέγιστη απόδοση εξαγωγής.",
      intro_en: "TFT provides end-to-end solutions for all vegetable oil production stages, from extraction and refining to filling and palletizing. We design to preserve organoleptic characteristics, minimize losses, and maximize extraction yield.",
      solutions: {
        process_gr: [
          "Καθαρισμός και προετοιμασία σπόρων/καρπών",
          "Μηχανική εξαγωγή (cold pressing) ή διαλυτοποίηση",
          "Degumming και neutralization για αφαίρεση φωσφολιπιδίων",
          "Bleaching για αφαίρεση χρωματικών ουσιών",
          "Deodorization για αφαίρεση οσμών και γεύσεων",
          "Winterization για κρύα διαύγαση",
          "Φιλτράρισμα και ποιοτικός έλεγχος",
          "Αποθήκευση σε δεξαμενές inert gas"
        ],
        process_en: [
          "Seed/fruit cleaning and preparation",
          "Mechanical extraction (cold pressing) or solvent extraction",
          "Degumming and neutralization for phospholipid removal",
          "Bleaching for color pigment removal",
          "Deodorization for odor and flavor removal",
          "Winterization for cold clarification",
          "Filtration and quality control",
          "Storage in inert gas tanks"
        ],
        packaging_gr: [
          "Πλήρωση σε PET, γυάλινα μπουκάλια ή μεταλλικά δοχεία",
          "Volumetric ή mass flow fillers για ακρίβεια",
          "Καπάκωμα με tamper-evident seals",
          "Ετικετοποίηση με θρεπτικές πληροφορίες",
          "Inert gas flushing για παράταση shelf-life",
          "Δευτερογενής συσκευασία: shrink wrap, case packing"
        ],
        packaging_en: [
          "Filling in PET, glass bottles or metal containers",
          "Volumetric or mass flow fillers for accuracy",
          "Capping with tamper-evident seals",
          "Labeling with nutritional information",
          "Inert gas flushing for shelf-life extension",
          "Secondary packaging: shrink wrap, case packing"
        ],
        automation_gr: [
          "Ρομποτικός χειρισμός μπουκαλιών και κιβωτίων",
          "Αυτόματη παλετοποίηση με πολλαπλά patterns",
          "Έλεγχος επιπέδου πλήρωσης και βάρους",
          "X-ray για ανίχνευση ξένων σωμάτων",
          "MES για ιχνηλασιμότητα από origin έως consumer"
        ],
        automation_en: [
          "Robotic handling of bottles and boxes",
          "Automatic palletizing with multiple patterns",
          "Fill level and weight control",
          "X-ray for foreign body detection",
          "MES for traceability from origin to consumer"
        ],
        services_gr: [
          "Σχεδιασμός oil mill και refinery",
          "Εγκατάσταση, commissioning και εκπαίδευση",
          "Συμβόλαια συντήρησης και τεχνική υποστήριξη",
          "Process optimization για μέγιστη απόδοση"
        ],
        services_en: [
          "Oil mill and refinery design",
          "Installation, commissioning and training",
          "Maintenance contracts and technical support",
          "Process optimization for maximum yield"
        ]
      },
      benefits_gr: [
        "Υψηλή απόδοση εξαγωγής και ελάχιστες απώλειες",
        "Διατήρηση θρεπτικής αξίας και οργανοληπτικών χαρακτηριστικών",
        "Ευελιξία για διαφορετικά είδη ελαίων (ελαιόλαδο, ηλιέλαιο, καλαμποκέλαιο)",
        "Extended shelf-life με προστασία από οξείδωση"
      ],
      benefits_en: [
        "High extraction yield and minimal losses",
        "Preservation of nutritional value and organoleptic characteristics",
        "Flexibility for different oil types (olive, sunflower, corn)",
        "Extended shelf-life with oxidation protection"
      ]
    }
  },
  "oils-fats-fats": {
    page_id: "industries-oils-fats-fats",
    slug: "/industries/oils-fats/fats",
    industry: "Oils & Fats",
    subcategory: "Fats",
    meta: {
      title_gr: "Λίπη | Λύσεις Επεξεργασίας & Συσκευασίας | TFT",
      title_en: "Fats | Processing & Packaging Solutions | TFT",
      description_gr: "Ολοκληρωμένες λύσεις TFT για παραγωγή και συσκευασία μαργαρίνης, shortening και άλλων λιπών — από το blending έως την πλήρωση — με έμφαση στη σταθερή υφή και ποιότητα.",
      description_en: "Complete TFT solutions for margarine, shortening, and other fats production and packaging — from blending to filling — focusing on consistent texture and quality."
    },
    content: {
      intro_gr: "Η TFT σχεδιάζει και υλοποιεί ολοκληρωμένες γραμμές για την παραγωγή μαργαρίνης, shortening, spreads και άλλων λιπαρών προϊόντων. Οι λύσεις μας καλύπτουν το blending, την κρυστάλλωση, την πλαστικοποίηση και τη συσκευασία, εξασφαλίζοντας σταθερή υφή, γεύση και ποιότητα.",
      intro_en: "TFT designs and implements complete lines for margarine, shortening, spreads, and other fat products production. Our solutions cover blending, crystallization, plasticization, and packaging, ensuring consistent texture, taste, and quality.",
      solutions: {
        process_gr: [
          "Blending υγρών/στερεών λιπών και εμουλγοποιητών",
          "Παστερίωση υδατικής φάσης",
          "Εμουλγοποίηση (emulsification) με high-shear mixers",
          "Crystallization σε scraped surface heat exchangers",
          "Πλαστικοποίηση και resting για σταθερή υφή",
          "Προσθήκη αρωμάτων, χρωμάτων και βιταμινών",
          "CIP/SIP συστήματα για απόλυτη υγιεινή"
        ],
        process_en: [
          "Blending of liquid/solid fats and emulsifiers",
          "Pasteurization of aqueous phase",
          "Emulsification with high-shear mixers",
          "Crystallization in scraped surface heat exchangers",
          "Plasticization and resting for stable texture",
          "Addition of flavors, colors, and vitamins",
          "CIP/SIP systems for absolute hygiene"
        ],
        packaging_gr: [
          "Πλήρωση σε tubs (250g, 500g, 1kg)",
          "Πλήρωση σε blocks για βιομηχανική χρήση",
          "Wrapping σε φύλλο αλουμινίου",
          "IML (In-Mold Labeling) για premium presentation",
          "Καπάκωμα και date coding",
          "Δευτερογενής συσκευασία: χαρτοκιβώτια και παλέτες"
        ],
        packaging_en: [
          "Filling in tubs (250g, 500g, 1kg)",
          "Block filling for industrial use",
          "Foil wrapping",
          "IML (In-Mold Labeling) for premium presentation",
          "Capping and date coding",
          "Secondary packaging: cartons and pallets"
        ],
        automation_gr: [
          "Αυτόματη δοσομέτρηση και mixing συστατικών",
          "Ρομποτικός εγκιβωτισμός tubs και blocks",
          "Παλετοποίηση με temperature-controlled patterns",
          "Έλεγχος βάρους και ποιότητας",
          "Batch tracking και ιχνηλασιμότητα"
        ],
        automation_en: [
          "Automatic dosing and ingredient mixing",
          "Robotic case packing of tubs and blocks",
          "Palletizing with temperature-controlled patterns",
          "Weight and quality control",
          "Batch tracking and traceability"
        ],
        lab_gr: [
          "Ανάλυση λιπαρών οξέων και trans fats",
          "Hardness testing και texture analysis",
          "Σημείο τήξης και σταθερότητα σε θερμοκρασίες",
          "Μικροβιολογικός έλεγχος",
          "Οργανοληπτική αξιολόγηση (spreadability, taste)"
        ],
        lab_en: [
          "Fatty acid and trans fat analysis",
          "Hardness testing and texture analysis",
          "Melting point and temperature stability",
          "Microbiological control",
          "Sensory evaluation (spreadability, taste)"
        ],
        services_gr: [
          "Σχεδιασμός margarine/shortening plant",
          "Εγκατάσταση, commissioning και εκπαίδευση",
          "Ανάπτυξη συνταγών και product development",
          "Συμβόλαια συντήρησης και technical support"
        ],
        services_en: [
          "Margarine/shortening plant design",
          "Installation, commissioning and training",
          "Recipe development and product development",
          "Maintenance contracts and technical support"
        ]
      },
      benefits_gr: [
        "Σταθερή υφή και spreadability σε όλο το shelf-life",
        "Ευελιξία για διαφορετικά formats (tubs, blocks, foil)",
        "Υψηλή ποιότητα με ελεγχόμενη κρυστάλλωση",
        "Compliance με nutritional standards (χαμηλά trans fats)"
      ],
      benefits_en: [
        "Consistent texture and spreadability throughout shelf-life",
        "Flexibility for different formats (tubs, blocks, foil)",
        "High quality with controlled crystallization",
        "Compliance with nutritional standards (low trans fats)"
      ]
    }
  }
};
